import {Notification} from '@app/gen/schemas/notification';
import {NotificationData} from '@app/gen/schemas/notification-data';
import {isAbsoluteUrl} from '@ui/utils/urls/is-absolute-url';

const EMPTY_SHARE_PATHS = new Set(['', '/drive/s/', '/drive/s/undefined', '/drive/s/null']);

const EMIT_ONLY_ACTIONS = new Set(['join', 'decline', 'deny']);

export function notificationActionPath(action?: string | null): string | null {
  if (!action) {
    return null;
  }
  const trimmed = action.trim();
  if (!trimmed || EMPTY_SHARE_PATHS.has(trimmed)) {
    return null;
  }
  if (isAbsoluteUrl(trimmed) || trimmed.startsWith('/')) {
    return trimmed;
  }
  return `/${trimmed}`;
}

function lineActionPath(
  line?: NotificationData['lines'][number],
): string | null {
  const action = line?.action;
  if (!action) {
    return null;
  }
  if (typeof action === 'string') {
    return notificationActionPath(action);
  }
  return notificationActionPath(action.action);
}

export function notificationDestination(
  notification: Notification,
): string | null {
  const data = notification.data;
  const main = notificationActionPath(data.mainAction?.action);
  if (main) {
    return main;
  }

  for (const line of data.lines ?? []) {
    const path = lineActionPath(line);
    if (path) {
      return path;
    }
  }

  for (const button of data.buttonActions ?? []) {
    if (button.emitOnly || EMIT_ONLY_ACTIONS.has(button.action) || button.action.startsWith('approve:')) {
      continue;
    }
    const path = notificationActionPath(button.action);
    if (path) {
      return path;
    }
  }

  const type = notification.type ?? '';
  if (type.includes('ShareAccessDenied')) {
    return '/drive';
  }
  if (type.includes('ShareAccessGranted') || type.includes('FileEntryShared')) {
    return '/drive/shares';
  }
  if (type.includes('ContactPageMessage')) {
    return '/admin';
  }
  if (type.includes('WorkspaceInvitation')) {
    return '/account-settings/workspaces';
  }

  return null;
}
